export const formatFileSize = (bytes: number) => {
	if (bytes < 1024) return `${bytes} bytes`
	const kb = bytes / 1024
	if (kb < 1024) return `${kb.toFixed(1)} KB`
	const mb = kb / 1024
	if (mb < 1024) return `${mb.toFixed(1)} MB`
	const gb = mb / 1024
	if (gb < 1024) return `${gb.toFixed(1)} GB`
	const tb = gb / 1024
	if (tb < 1024) return `${tb.toFixed(1)} TB`
	const pb = tb / 1024
	if (pb < 1024) return `${pb.toFixed(1)} PB`
	const eb = pb / 1024
	return `${eb.toFixed(1)} EB`
}
